module.exports = __webpack_public_path__ + "img/ver4.c4a195fc.jpg";